var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-breadcrumbs',{staticClass:"px-0 mb-5 mb-sm-0",attrs:{"divider":">","items":_vm.bc}}),_c('div',{staticClass:"single-post-details-area"},[_c('router-view',{attrs:{"bc":_vm.bc}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }